import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { t } from '../../i18n.ts';
import Button from '../svelte-button.svelte';

var root = $.from_html(`<section data-step-empty="true" class="step-welcome svelte-zvvyz5"><div data-part="welcome-eyebrow" class="svelte-zvvyz5"> </div> <h2 data-part="welcome-title" class="svelte-zvvyz5"> </h2> <p data-part="welcome-copy" class="svelte-zvvyz5"> </p> <div data-part="welcome-actions" class="svelte-zvvyz5"><!> <a class="welcome-link-button svelte-zvvyz5" target="_blank" rel="noreferrer"> </a> <a class="welcome-link-button svelte-zvvyz5" target="_blank" rel="noreferrer"> </a></div> <div data-part="welcome-examples" class="svelte-zvvyz5"><div data-part="welcome-section-title" class="svelte-zvvyz5"> </div> <div data-part="welcome-example-list" class="svelte-zvvyz5"></div></div> <p data-part="welcome-step-hint" class="svelte-zvvyz5"> </p></section>`);

const $$css = {
	hash: 'svelte-zvvyz5',
	code: '[data-step-empty="true"].svelte-zvvyz5 {min-width:0;border:1px solid var(--color-panel-border-strong);border-radius:14px;padding:18px;background:linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--color-panel-2), var(--color-bg) 2%),\n      color-mix(in srgb, var(--color-panel), var(--color-bg) 10%)\n    );display:grid;gap:14px;}[data-part="welcome-eyebrow"].svelte-zvvyz5 {font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--color-accent);font-weight:700;}[data-part="welcome-title"].svelte-zvvyz5 {margin:0;font-size:24px;line-height:1.1;color:var(--color-text-strong);}[data-part="welcome-copy"].svelte-zvvyz5,\n  [data-part="welcome-step-hint"].svelte-zvvyz5 {margin:0;font-size:13px;line-height:1.6;color:var(--color-text);}[data-part="welcome-actions"].svelte-zvvyz5 {display:flex;flex-wrap:wrap;gap:8px;}[data-part="welcome-examples"].svelte-zvvyz5 {padding-top:8px;border-top:1px solid color-mix(in srgb, var(--color-line), transparent 30%);}[data-part="welcome-section-title"].svelte-zvvyz5 {font-size:11px;font-weight:700;color:var(--color-muted);text-transform:uppercase;letter-spacing:0.08em;margin-bottom:8px;}[data-part="welcome-example-list"].svelte-zvvyz5 {display:flex;flex-wrap:wrap;gap:8px;}.welcome-link-button.svelte-zvvyz5 {display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--color-line);background:var(--color-panel);border-radius:8px;padding:6px 11px;font-size:12px;color:var(--color-muted);text-decoration:none;cursor:pointer;transition:120ms ease;}.welcome-link-button.svelte-zvvyz5:hover {border-color:var(--color-accent);transform:translateY(-1px);}button.button.welcome-example-button {padding:4px 8px;font-size:11px;}'
};

export default function Svelte_step_welcome($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const WELCOME_EXAMPLES = [
		'StandardToon',
		'HueShiftToon',
		'HueSatShiftToon',
		'Gradient',
		'Plastic',
		'Metallic'
	];

	const GITHUB_URL = 'https://github.com/mfakane/lutchainer';
	const BLENDER_ADDON_URL = 'https://github.com/mfakane/lutchainer/releases';

	const tr = $.prop($$props, 'tr', 7),
		onOpenPipelineFilePicker = $.prop($$props, 'onOpenPipelineFilePicker', 7, () => undefined),
		onLoadExample = $.prop($$props, 'onLoadExample', 7, () => undefined),
		onStatus = $.prop($$props, 'onStatus', 7, () => undefined);

	async function handleLoadExample(example) {
		try {
			await onLoadExample()(example);
		} catch(error) {
			const message = error instanceof Error ? error.message : tr()('common.unknownError');

			onStatus()(tr()('header.status.pipelineLoadFailed', { message }), 'error');
		}
	}

	var $$exports = {
		get tr() {
			return tr();
		},

		set tr($$value) {
			tr($$value);
			$.flush();
		},

		get onOpenPipelineFilePicker() {
			return onOpenPipelineFilePicker();
		},

		set onOpenPipelineFilePicker($$value = () => undefined) {
			onOpenPipelineFilePicker($$value);
			$.flush();
		},

		get onLoadExample() {
			return onLoadExample();
		},

		set onLoadExample($$value = () => undefined) {
			onLoadExample($$value);
			$.flush();
		},

		get onStatus() {
			return onStatus();
		},

		set onStatus($$value = () => undefined) {
			onStatus($$value);
			$.flush();
		}
	};

	var section = root();
	var div = $.child(section);
	var text = $.only_child(div, true);
	var h2 = $.sibling(div, 2);
	var text_1 = $.only_child(h2, true);
	var p = $.sibling(h2, 2);
	var text_2 = $.only_child(p, true);
	var div_1 = $.sibling(p, 2);
	var node = $.child(div_1);

	Button(node, {
		variant: 'secondary',
		get handlePress() {
			return onOpenPipelineFilePicker();
		},

		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_3 = $.text();

			$.template_effect(($0) => $.set_text(text_3, $0), [() => tr()('pipeline.welcome.load')]);
			$.append($$anchor, text_3);
		},
		$$slots: { default: true }
	});

	var a = $.sibling(node, 2);

	$.set_attribute(a, 'href', GITHUB_URL);

	var text_4 = $.only_child(a, true);
	var a_1 = $.sibling(a, 2);

	$.set_attribute(a_1, 'href', BLENDER_ADDON_URL);

	var text_5 = $.only_child(a_1, true);

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var div_3 = $.child(div_2);
	var text_6 = $.only_child(div_3, true);
	var div_4 = $.sibling(div_3, 2);

	$.each(div_4, 20, () => WELCOME_EXAMPLES, (example) => example, ($$anchor, example) => {
		Button($$anchor, {
			className: 'welcome-example-button',
			handlePress: () => void handleLoadExample(example),
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_7 = $.text();

				$.template_effect(() => $.set_text(text_7, example));
				$.append($$anchor, text_7);
			},
			$$slots: { default: true }
		});
	});

	$.reset(div_4);
	$.reset(div_2);

	var p_1 = $.sibling(div_2, 2);
	var text_8 = $.only_child(p_1, true);

	$.reset(section);

	$.template_effect(
		($0, $1, $2, $3, $4, $5, $6) => {
			$.set_text(text, $0);
			$.set_text(text_1, $1);
			$.set_text(text_2, $2);
			$.set_text(text_4, $3);
			$.set_text(text_5, $4);
			$.set_text(text_6, $5);
			$.set_text(text_8, $6);
		},
		[
			() => tr()('pipeline.welcome.eyebrow'),
			() => tr()('pipeline.welcome.title'),
			() => tr()('pipeline.welcome.description'),
			() => tr()('pipeline.welcome.github'),
			() => tr()('pipeline.welcome.blenderAddon'),
			() => tr()('pipeline.welcome.examplesTitle'),
			() => tr()('pipeline.welcome.stepHint')
		]
	);

	$.append($$anchor, section);

	return $.pop($$exports);
}

$.create_custom_element(
	Svelte_step_welcome,
	{
		tr: {},
		onOpenPipelineFilePicker: {},
		onLoadExample: {},
		onStatus: {}
	},
	[],
	[],
	{ mode: 'open' }
);